
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.NoGps = {

  template: Greenmile.Checks.EventCheck.NoAttributes.template,

  assignParameter() {
  },
  retrieveParameter() {
    return JSON.stringify({
      nogps: true,
    });
  },

};
